// 处理vhvw布局高度问题
function handleContainerHeight(className) {
  let bodyClientHeight = document.body.clientHeight;
  document.querySelector(className).style.height = `${bodyClientHeight}px`;
}

// 注册全局函数
export function registerGlobalFunction(vue) {
  vue.prototype.$globalFunction = {
    handleContainerHeight,
  };
}
